import { Pipe, PipeTransform } from "@angular/core";
import { DateTimeHelper } from "../helpers/datetime-converter.helper";

@Pipe({
  name: "customDateTime",
  standalone: true,
})
export class CustomDateTimePipe implements PipeTransform {
  transform(value: string, select: string): string {
    if (select === "date") {
      return DateTimeHelper.fromIsoFormat(value).date;
    } else if (select === "time") {
      return DateTimeHelper.fromIsoFormat(value).time;
    } else {
      return "ERROR";
    }
  }
}
